import { mapValues } from 'lodash/fp';

import { ApiResource } from 'lib/interfaces/api';

export const mergeResourceWithFormValues = <T extends ApiResource<any, {}>>(
  resource: T,
  formValues: Partial<T['attributes']>,
): T => {
  const resourceAttributesUnfiltered = {
    ...(resource && resource.attributes),
    ...formValues,
  };

  const resourceAttributes = mapValues((value) => {
    return value === 0 || value ? value : null;
  }, resourceAttributesUnfiltered);

  return {
    ...resource,
    attributes: resourceAttributes,
  };
};
